module.exports = __webpack_public_path__ + "media/images/discover-8fe942a6ab366642b7c3a4b722473c8c.webp";